import _ from 'lodash'
import createReactClass from 'create-react-class'

import { SchemaBranchMixin } from 'legacy/libs/baobab-react-mixins'
import { ResolveMixin } from 'legacy/libs/baobab-react-resolver'
import branchingQuestionApi from 'legacy/api/branching-question'
import { ValidationBox, MultipleCheckBox } from 'legacy/libs/react-form-tools'

import { Spinner } from 'common'

export default createReactClass({
  displayName: 'BranchingQuestionsSelect',

  mixins: [SchemaBranchMixin, ResolveMixin],

  schema: {
    branchingQuestions: {},
    branches: [],
    poll: null,
  },

  getResolverBindings() {
    if (!this.state.poll) {
      return []
    }

    return [
      {
        cursor: this.cursors.branchingQuestions,
        service: () =>
          branchingQuestionApi.getList({
            parent_poll: this.state.poll,
          }),
        initialData: [],
        alwaysLoad: true,
      },
    ]
  },

  componentDidUpdate(prevProps, prevState) {
    if (prevState.poll !== this.state.poll) {
      this.onPollUpdate()
    }
  },

  onPollUpdate() {
    this.resolve()
    this.cursors.branches.set([])
  },

  render() {
    if (this.isLoading()) {
      return <Spinner />
    }

    return (
      <ValidationBox fieldPath="branches" className="text-danger">
        {_.map(
          this.state.branchingQuestions.data,
          (question, questionIndex) => (
            <div className="my-8" key={questionIndex}>
              <div className="mb-2">
                <label className="text-default-light">{question.name}</label>
              </div>

              <div className="grid gap-6 sm:grid-cols-3">
                {_.map(question.branches, (branch) => (
                  <div className="flex items-start gap-x-2" key={branch.pk}>
                    <MultipleCheckBox
                      className="translate-y-[0.25em]"
                      value={branch.pk}
                      id={`branch_${branch.pk}`}
                    />

                    <div>
                      <label
                        className="mb-1 inline-block"
                        htmlFor={`branch_${branch.pk}`}
                      >
                        {branch.name}
                      </label>

                      <p className="text-xs text-default-light">
                        {branch.tooltip}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )
        )}
      </ValidationBox>
    )
  },
})
